





















import {Vue, Component, Prop} from "vue-property-decorator";
import Lens from '../../../assets/svg/lens.svg';
import MiniClose from '../../../assets/svg/mini-close.svg';

import ControlWrapper from "../ControlWrapper.vue"

@Component( {
    components: { MiniClose, Lens, ControlWrapper }
})
export default class SearchInput extends Vue {
    @Prop() value: string;
    @Prop({required: false}) placeholder: string;
    @Prop({default: "large"}) size: "large" | "middle" | "small";

    get placeholderText() {
        return this.placeholder !== undefined ? this.placeholder : this.$t('common.search')
    }

    clear() {
        this.$emit('input', '');
    }
}
